import { createFileRoute } from '@tanstack/react-router'
import { loaderScope } from '~/features/medical/queries'
import { prospectsQuery } from '~/features/scouting/queries'
import { TalentBoard, type TalentSearch } from '~/features/scouting/TalentBoard'

export const Route = createFileRoute('/_app/kader/talente/')({
  validateSearch: (s: Record<string, unknown>): TalentSearch => ({
    ...(s.ansicht === 'liste' ? { ansicht: 'liste' as const } : {}),
    ...(s.archiv === true || s.archiv === 'true' ? { archiv: true as const } : {}),
  }),
  loaderDeps: ({ search }) => ({ archiv: !!search.archiv }),
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    const session = context.queryClient.getQueryData<{ active?: { permissions: string[] } | null }>(['session'])
    if (!scope || !session?.active?.permissions.includes('scouting.read')) return
    await context.queryClient.ensureQueryData(prospectsQuery(scope.teamId, deps.archiv))
  },
  component: function Talente() {
    return <TalentBoard search={Route.useSearch()} />
  },
})
